import { Colours } from "../../../utils/colours";
import CmsMapLocationModal from "../../CmsMapLocationModal/CmsMapLocationModal";
import { Button } from "../../common";
import { Cross } from "../../common/Icons";
import * as styles from "./CmsMapOverlayCard.module.scss";

import React, { useEffect, useState } from "react";

export interface CmsMapOverlayCardProps extends DogsTrust.CmsMapCardProps {
	shouldOpenModal?: boolean;
	cmsMapName: string;
	onClose?: () => void;
}

export const CmsMapOverlayCard: React.FC<CmsMapOverlayCardProps> = ({
	ctaUrl,
	ctaLabel,
	shouldOpenModal,
	cmsMapName,
	location,
	secondaryInfoText,
	secondaryInfoTitle,
	tertiaryInfoText,
	subTitle,
	googleMapsUrl,
	onClose,
}) => {
	const [modalIsOpen, setModalIsOpen] = useState(false);

	const openModal = () => {
		setModalIsOpen(true);
	};

	const closeModal = () => {
		setModalIsOpen(false);
	};

	useEffect(() => {
		if (modalIsOpen) {
			document.getElementsByTagName("body")[0].style.overflow = "hidden";
		} else {
			document.getElementsByTagName("body")[0].style.overflow = "scroll";
		}
		return () => {
			document.getElementsByTagName("body")[0].style.overflow = "scroll";
		};
	}, [modalIsOpen]);
	return (
		<>
			<div className={styles.cardcontainer}>
				<button
					aria-label="Close overlay card"
					className={styles.closeicon}
					type="button"
					onClick={onClose}
				>
					<Cross fill={Colours.MIDNIGHT} height="18px" />
				</button>
				<p className={styles.title}>{cmsMapName}</p>
				<p className={styles.location}>{location}</p>
				{(shouldOpenModal || ctaUrl) && (
					<div className={styles.cardsectionbreak} />
				)}
				{ctaUrl && ctaLabel && (
					<Button
						variant={"primary"}
						url={ctaUrl}
						title={"More information"}
						size={"small"}
						fullWidth={true}
					>
						{ctaLabel}
					</Button>
				)}
				{shouldOpenModal && !ctaUrl && !ctaLabel && (
					<Button
						variant={"primary"}
						onClick={openModal}
						title={"Open modal for more information"}
						size={"small"}
					>
						More information
					</Button>
				)}
			</div>
			<CmsMapLocationModal
				modalState={modalIsOpen}
				title={cmsMapName}
				subTitle={subTitle}
				secondaryInfoText={secondaryInfoText}
				secondaryInfoTitle={secondaryInfoTitle}
				tertiaryInfoText={tertiaryInfoText}
				location={location}
				googleMapsUrl={googleMapsUrl}
				onClickCancel={closeModal}
			/>
		</>
	);
};

export default CmsMapOverlayCard;
